import { useState } from "react";
import { FilterSection } from "./FilterSection";
import ListView from "./ListView";
import { AddCouponModal } from "./modals/AddCouponModal";
import { EditCouponModal } from "./modals/EditCouponModal";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { CouponFilter } from "./coupon";
import CouponInfoModal from "./modals/CouponInfoModal";
import { Outlet } from "react-router-dom";
import { useFilter } from "../../hooks/useFilter";

export function CouponsScreen() {
  useDocumentTitle("Coupons");
  const [filter, setFilter] = useFilter<CouponFilter>({ page: 1, search: "" });

  const handleFilter = (params: any) => {
    setFilter((prev) => ({ ...prev, ...params }));
  };
  return (
    <>
      <div>
        <FilterSection filter={filter} handleFilter={handleFilter} />
        <div style={{ marginTop: "2.8125rem", minHeight: "18.75rem" }}>
          <ListView filter={filter} handleFilter={handleFilter} />
        </div>
        <Outlet />
      </div>
    </>
  );
}

export const couponRoutes = () => ({
  path: "coupons",
  element: <CouponsScreen />,
  children: [
    { path: "add", element: <AddCouponModal /> },
    { path: ":couponId", element: <CouponInfoModal /> },
    { path: ":couponId/edit", element: <EditCouponModal /> },
  ],
});
